import React from 'react';
import ReactSelect from 'react-select';

const Select = ({ 
  options, 
  value, 
  onChange, 
  placeholder, 
  error, 
  label, 
  className = "",
  isSearchable = false,
  ...props 
}) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: '#f8fafc', // slate-50
      borderColor: error ? '#ef4444' : (state.isFocused ? '#0F172A' : '#e2e8f0'), // red-500 : slate-900 : slate-200
      borderRadius: '0.75rem',
      padding: '2px',
      fontSize: '0.875rem',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(15, 23, 42, 0.1)' : 'none',
      '&:hover': {
        borderColor: error ? '#ef4444' : '#cbd5e1',
      },
      transition: 'all 0.2s ease',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected 
        ? '#0F172A' 
        : (state.isFocused ? '#f1f5f9' : 'white'),
      color: state.isSelected ? 'white' : '#334155',
      fontSize: '0.875rem',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#e2e8f0',
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '0.75rem',
      overflow: 'hidden',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      border: '1px solid #f1f5f9',
    }),
    singleValue: (base) => ({
      ...base,
      color: '#0f172a',
    }),
    placeholder: (base) => ({
      ...base,
      color: '#94a3b8',
    }),
  };

  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && <label className="block text-sm font-semibold text-slate-700">{label}</label>}
      <ReactSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        styles={customStyles}
        isSearchable={isSearchable}
        {...props}
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default Select;
